<template>
  <div>
    <div>
      <b-navbar
        fixed="top"
        toggleable="lg"
        type="light"
        variant="secondary"
        class="shadow"
        style="padding: 0 1rem"
      >
        <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>

        <b-navbar-brand
          ><img
            :src="publicPath + 'images/logo_footer.png'"
            style="height: 38px"
        /></b-navbar-brand>

        <b-collapse id="nav-text-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item
              v-if="$store.getters.isAdmin"
              :to="{ name: 'creditors' }"
              class="mr-2"
              >Créanciers</b-nav-item
            >
            <b-nav-item :to="{ name: 'debtors' }" class="mr-2"
              >Débiteurs</b-nav-item
            >
            <b-nav-item
              v-if="$store.getters.isAdmin"
              :to="{ name: 'payments' }"
              class="mr-2"
              >Paiements</b-nav-item
            >
            <b-nav-item
              v-if="$store.getters.isAdmin"
              :to="{ name: 'invoices' }"
              class="mr-2"
              >Factures</b-nav-item
            >
            <b-nav-item
              v-if="$store.getters.isAdmin"
              :to="{ name: 'account-statements' }"
              class="mr-2"
              >Relevés</b-nav-item
            >
            <b-nav-item :to="{ name: 'home' }" class="mr-2">Gestion</b-nav-item>
            <b-nav-item :to="{ name: 'warrants' }" class="mr-2"
              >Mandats</b-nav-item
            >

            <b-nav-item
              v-if="superadmin"
              :to="{ name: 'administration' }"
              class="mr-2"
              >Admin</b-nav-item
            >
            <b-nav-form>
              <b-button
                v-if="unread_notes > 0"
                :to="{ name: 'unreadNotes' }"
                icon
                size="sm"
                variant="light"
                style="padding-top: 0; padding-bottom: 0"
              >
                <i class="fad fa-bell"></i>
                <b-badge class="ml-2" variant="danger"
                  >{{ unread_notes }}
                </b-badge>
              </b-button>
              <b-button
                v-if="mails_to_send > 0 && $store.getters.isAdmin"
                size="sm"
                class="ml-2"
                variant="light"
                :to="{ name: 'mailsToSend' }"
                style="padding-top: 0; padding-bottom: 0"
                ><i class="fad fa-envelope"></i>
                <b-badge class="ml-2" variant="danger"
                  >{{ mails_to_send }}
                </b-badge></b-button
              >

              <b-dropdown
                size="sm"
                variant="light"
                class="ml-2 history-dropdown"
                no-caret
              >
                <template #button-content>
                  <i class="fad fa-clock"></i>
                  <b-badge class="ml-2" variant="info"
                    >{{ history.length }}
                  </b-badge>
                </template>
                <template v-for="item in history">
                  <b-dropdown-item
                    :to="{
                      name: 'warrantView',
                      params: { id: item.mainObjectID },
                    }"
                    target="_blank"
                    :key="item.ID"
                  >
                    {{ formatHistory(item) }}
                  </b-dropdown-item>
                </template>
                <b-dropdown-item :to="{ name: 'frontHistory' }">
                  <i>Plus...</i>
                </b-dropdown-item>
              </b-dropdown>
              <b-dropdown
                size="sm"
                v-if="connected.length > 0"
                variant="light"
                class="ml-2 history-dropdown"
                no-caret
              >
                <template #button-content>
                  <i class="fad fa-users"></i>
                  <b-badge class="ml-2" variant="info"
                    >{{ connected.length }}
                  </b-badge>
                </template>
                <template v-for="item in connected">
                  <b-dropdown-item :key="item.ID">
                    {{ item.prenom }} {{ item.nom }}
                  </b-dropdown-item>
                </template>
              </b-dropdown>
              <b-dropdown
                size="sm"
                v-if="jobs.length > 0"
                variant="light"
                class="ml-2"
                no-caret
              >
                <template #button-content>
                  <i class="fad fa-cog"></i>
                  <b-badge class="ml-2" variant="info"
                    >{{ jobs.length }}
                  </b-badge>
                </template>
                <template v-for="item in jobs">
                  <b-dropdown-item
                    :key="item.ID"
                    style="font-size: 0.8rem; width: 400px"
                  >
                    <b-row>
                      <b-col lg="10">
                        <strong>{{ item.initiale }}</strong>
                        - {{ item.label }} -
                        <i>{{ toDate(item.update_time) }}</i>
                      </b-col>
                      <b-col lg="2">
                        <div class="float-right">
                          <b-icon-pause-fill
                            v-if="item.status == 'queued'"
                            class="text-warning"
                          ></b-icon-pause-fill>
                          <b-icon-check
                            v-if="
                              item.status == 'finished' && !item.error_message
                            "
                            class="text-success"
                          ></b-icon-check>
                          <b-icon-x
                            v-else-if="item.status == 'finished'"
                            class="text-danger"
                          ></b-icon-x>
                          <b-icon-gear-fill
                            v-else-if="item.status == 'processing'"
                            animation="spin"
                            class="text-secondary"
                          ></b-icon-gear-fill>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1" v-if="item.current_step !== null">
                      <b-col lg="12">
                        <b-progress
                          variant="success"
                          :value="item.current_step"
                          :max="item.total_steps"
                          show-progress
                          :animated="item.current_step !== item.total_steps"
                        ></b-progress>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="item.response && item.response.data.action"
                      class="mt-1"
                    >
                      <b-col lg="12">
                        <b-button
                          size="sm"
                          v-if="item.response.data.action.button"
                          @click="manageJobAction(item.response.data.action)"
                        >
                          <span
                            v-if="item.response.data.action.icon"
                            v-html="icon(item.response.data.action.icon)"
                          ></span
                          ><span class="ml-2">{{
                            item.response.data.action.button
                          }}</span>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-dropdown-item>
                </template>
              </b-dropdown>
            </b-nav-form>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-text class="mr-3">Mandat N°</b-nav-text>
            <mh-input
              @enter="goSearch"
              class="mt-1 mr-2"
              :table="table"
              field="search"
              :autocomplete="getField()"
            ></mh-input>

            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template #button-content>
                {{ $store.getters.userProfile.preferred_username }}
              </template>
              <b-dropdown-item href="#">Profil</b-dropdown-item>
              <b-dropdown-item @click="$store.dispatch('logout')"
                >Se déconnecter</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import MhInput from "./MhInput.vue";
import poll from "@/services/poll";
import DateTime from "@/services/DateTime.js";
export default {
  components: { MhInput },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      superadmin: this.$store.getters.isSuperAdmin,
      unread_notes: 0,
      mails_to_send: 0,
      connected: [],
      history: [],
      jobs: [],
      history_fields: [
        {
          key: "timestamp",
          label: "Horodatage",
        },
        {
          key: "message",
          label: "Mandat",
        },
      ],
      myInterval: null,
      table: {
        type: {
          label: null,
          value: "mandat",
          options: [
            {
              value: "mandat",
              text: "Mandat",
            },
            {
              value: "facture",
              text: "Facture",
            },
            {
              value: "creancier",
              text: "Créancier",
            },
            {
              value: "debiteur",
              text: "Débiteur",
            },
          ],
        },
        search: {
          label: null,
          type: "varchar",
          value: "",
        },
      },
    };
  },
  created() {
    this.load();
    this.myInterval = setInterval(() => {
      this.load();
    }, 15000);
    if (this.$store.getters.isNegotiator) {
      this.table.type.options = [
        {
          value: "mandat",
          text: "Mandat",
        },
      ];
    }
  },
  beforeDestroy() {
    clearInterval(this.myInterval);
  },
  methods: {
    toDate(d) {
      return DateTime.humanDateTime(d);
    },
    icon(i) {
      return `<i class="${i}"></i>`;
    },
    manageJobAction(item) {
      if (item.pdf_file) {
        window.open(
          this.$store.getters.url + "/upload/documents/" + item.pdf_file,
          "_blank"
        );
      }
    },
    formatHistory(item) {
      let debiteur = "";
      if (item.nom_soc !== "") {
        debiteur = item.nom_soc;
      } else {
        debiteur = (item.prenom + " " + item.nom).trim();
      }
      return "#" + item.mainObjectID + " " + item.creancier + " / " + debiteur;
    },
    goSearch(payload) {
      let id;
      if (payload.table && payload.id) {
        id = payload.id;
      } else {
        id = payload;
      }
      switch (this.table.type.value) {
        case "mandat":
          this.$router.push({ name: "warrantView", params: { id: id } });
          break;
        case "facture":
          this.$router.push({ name: "invoiceView", params: { id: id } });
          break;
        case "creancier":
          this.$router.push({ name: "creditorView", params: { id: id } });
          break;
        case "debiteur":
          this.$router.push({ name: "debtorEdit", params: { id: id } });
          break;
      }
      this.table.search.value = "";
    },
    getField() {
      switch (this.table.type.value) {
        case "mandat":
          return { idHistory: "globalWarrantID", field: "mandat.ID" };
        case "facture":
          return { idHistory: "globalInvoiceID", field: "facture.ID" };
        case "creancier":
          return { idHistory: "globalCreditorID", field: "creancier.ID" };
        case "debiteur":
          return { idHistory: "globalDebtorID", field: "debiteur.ID" };
      }
    },
    load() {
      poll.get().then((response) => {
        this.unread_notes = response.data.unread_notes || [];
        this.mails_to_send = response.data.mails_to_send || [];
        this.history = response.data.history || [];
        this.connected = response.data.connected || [];
        this.jobs = response.data.jobs || [];
        this.$store.commit("set_jobs", this.jobs);
      });
    },
  },
};
</script>
<style lang="scss">
.nav-link {
  font-size: 0.9rem !important;
}
.history-dropdown .dropdown-menu {
  max-height: 50vh;
  overflow-y: auto;
}
</style>
<style lang="scss" scoped>
.form-control[type="text"] {
  transition: all 0.3s;
}
.navbar-brand img {
  height: 47px;
}
.navbar-light .navbar-toggler {
  color: gray !important;
}
</style>